var map = {
	"./cz-CZ.json": 23014,
	"./da-DK.json": 53292,
	"./de-DE.json": 1686,
	"./en-GB.json": 50964,
	"./en-US.json": 56989,
	"./es-ES.json": 66400,
	"./fr-FR.json": 26412,
	"./hu-HU.json": 23366,
	"./is-IS.json": 51768,
	"./nl-NL.json": 57796,
	"./pl-PL.json": 77728,
	"./ru-RU.json": 46850,
	"./sv-SE.json": 27887,
	"@/i18n/cz-CZ.json": 23014,
	"@/i18n/da-DK.json": 53292,
	"@/i18n/de-DE.json": 1686,
	"@/i18n/en-GB.json": 50964,
	"@/i18n/en-US.json": 56989,
	"@/i18n/es-ES.json": 66400,
	"@/i18n/fr-FR.json": 26412,
	"@/i18n/hu-HU.json": 23366,
	"@/i18n/is-IS.json": 51768,
	"@/i18n/nl-NL.json": 57796,
	"@/i18n/pl-PL.json": 77728,
	"@/i18n/ru-RU.json": 46850,
	"@/i18n/sv-SE.json": 27887
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 53480;